import { render, staticRenderFns } from "./SessionExpired.vue?vue&type=template&id=19081b70&scoped=true"
import script from "./SessionExpired.vue?vue&type=script&lang=js"
export * from "./SessionExpired.vue?vue&type=script&lang=js"
import style0 from "./SessionExpired.vue?vue&type=style&index=0&id=19081b70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19081b70",
  null
  
)

export default component.exports